import * as React from 'react';
import { useSelector } from 'react-redux';
import { withProvider } from '../../redux';
import { selectConfigValue } from '../../selectors/config';
import { selectLocationsFromAddress } from '../../selectors/offer';
import { ApplicationContext } from '../ApplicationContext';
import { Device } from '../common/Device';
import { HAS_BEEN_CLOSED_MARK } from './constants';
import { N1PublicationBannerDesktop, N1PublicationBannerMobile } from './components';
import { IN1PublicationBannerContainerProps } from './types';

export const N1PublicationBannerContainer = () => {
  const locations = useSelector(selectLocationsFromAddress);
  const n1PublicationBannerLocations = useSelector(selectConfigValue('n1PublicationBannerLocations'));

  const isRequiredLocation = n1PublicationBannerLocations.some(location => locations.includes(location));

  const [isClosed, setIsClosed] = React.useState(!!sessionStorage.getItem(HAS_BEEN_CLOSED_MARK));

  const isVisible = isRequiredLocation && !isClosed;

  const handleCloseClick = React.useCallback(() => {
    sessionStorage.setItem(HAS_BEEN_CLOSED_MARK, '1');
    setIsClosed(true);
  }, []);

  if (!isVisible) {
    return null;
  }

  return (
    <Device
      desktop={<N1PublicationBannerDesktop handleCloseClick={handleCloseClick} />}
      mobile={<N1PublicationBannerMobile handleCloseClick={handleCloseClick} />}
    />
  );
};

export const N1PublicationBannerWrapper = withProvider((props: IN1PublicationBannerContainerProps) => {
  const { httpApi, logger, config, telemetry } = props;

  const context = React.useMemo(() => ({ httpApi, logger, config, telemetry }), [httpApi, logger, config, telemetry]);

  return (
    <ApplicationContext.Provider value={context}>
      <N1PublicationBannerContainer />
    </ApplicationContext.Provider>
  );
});
